import React from 'react';
import { MetricDisplay } from '../atoms/MetricDisplay';
import { formatCurrencyWhole } from '../../../../../shared/utils/currency';

interface FinancialSummaryRowProps {
  approved: number;
  booked: number;
  remaining: number;
}

export const FinancialSummaryRow: React.FC<FinancialSummaryRowProps> = ({
  approved,
  booked,
  remaining,
}) => {
  // Determine color for remaining based on value
  const remainingColor =
    remaining < 0 ? 'text-content-error' : 'text-content-success';

  return (
    <div className="flex gap-4">
      <div className="flex-1">
        <MetricDisplay
          label="Approved"
          value={formatCurrencyWhole(approved)}
          color="text-content-success"
        />
      </div>
      <div className="flex-1">
        <MetricDisplay
          label="Booked"
          value={formatCurrencyWhole(booked)}
          color="text-content-warning"
        />
      </div>
      <div className="flex-1">
        <MetricDisplay
          label="Remaining"
          value={formatCurrencyWhole(remaining)}
          color={remainingColor}
        />
      </div>
    </div>
  );
};
